"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _libphonenumberJs = require("libphonenumber-js");

var _utils = require("./utils");

var _utils2 = _interopRequireDefault(_utils);

var _clickOutside = require("./click-outside");

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _input = require("Resources/components/elements/mixins/input");

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function getDefault(key) {
  var value = _utils2.default.options[key];
  if (typeof value === "undefined") {
    return _utils2.default.options[key];
  }
  return value;
}

exports.default = {
  name: "TelInput",
  directives: {
    clickOutside: _clickOutside2.default
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    allCountries: {
      type: Array,
      default: function _default() {
        return getDefault("allCountries");
      }
    },
    autoFormat: {
      type: Boolean,
      default: function _default() {
        return getDefault("autoFormat");
      }
    },
    customValidate: {
      type: [Boolean, RegExp],
      default: function _default() {
        return getDefault("customValidate");
      }
    },
    defaultCountry: {
      // Default country code, ie: 'AU'
      // Will override the current country of user
      type: [String, Number],
      default: function _default() {
        return getDefault("defaultCountry");
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return getDefault("disabled");
      }
    },
    autoDefaultCountry: {
      type: Boolean,
      default: function _default() {
        return getDefault("autoDefaultCountry");
      }
    },
    dropdownOptions: {
      type: Object,
      default: function _default() {
        return getDefault("dropdownOptions");
      }
    },
    ignoredCountries: {
      type: Array,
      default: function _default() {
        return getDefault("ignoredCountries");
      }
    },
    inputOptions: {
      type: Object,
      default: function _default() {
        return getDefault("inputOptions");
      }
    },
    invalidMsg: {
      type: String,
      default: function _default() {
        return getDefault("invalidMsg");
      }
    },
    mode: {
      type: String,
      default: function _default() {
        return getDefault("mode");
      }
    },
    onlyCountries: {
      type: Array,
      default: function _default() {
        return getDefault("onlyCountries");
      }
    },
    preferredCountries: {
      type: Array,
      default: function _default() {
        return getDefault("preferredCountries");
      }
    },
    validCharactersOnly: {
      type: Boolean,
      default: function _default() {
        return getDefault("validCharactersOnly");
      }
    },
    styleClasses: {
      type: [String, Array, Object],
      default: function _default() {
        return getDefault("styleClasses");
      }
    }
  },
  data: function data() {
    return {
      phone: "",
      activeCountryCode: "",
      open: false,
      finishMounted: false,
      selectedIndex: null,
      typeToFindInput: "",
      typeToFindTimer: null,
      dropdownOpenDirection: "below",
      parsedPlaceholder: this.inputOptions.placeholder,
      searchQuery: ""
    };
  },


  mixins: [_input2.default],

  computed: {
    activeCountry: function activeCountry() {
      return this.findCountry(this.activeCountryCode);
    },
    parsedMode: function parsedMode() {
      if (this.mode === "auto") {
        if (!this.phone || this.phone[0] !== "+") {
          return "national";
        }
        return "international";
      }
      if (!["international", "national"].includes(this.mode)) {
        console.error('Invalid value of prop "mode"');
        return "international";
      }
      return this.mode;
    },
    filteredCountries: function filteredCountries() {
      var _this = this;

      // List countries after filtered
      if (this.onlyCountries.length) {
        return this.allCountries.filter(function (_ref) {
          var iso2 = _ref.iso2;
          return _this.onlyCountries.some(function (c) {
            return c.toUpperCase() === iso2;
          });
        });
      }

      if (this.ignoredCountries.length) {
        return this.allCountries.filter(function (_ref2) {
          var iso2 = _ref2.iso2;
          return !_this.ignoredCountries.includes(iso2.toUpperCase()) && !_this.ignoredCountries.includes(iso2.toLowerCase());
        });
      }

      return this.allCountries;
    },
    sortedCountries: function sortedCountries() {
      var _this2 = this;

      // Sort the list countries: from preferred countries to all countries
      var preferredCountries = this.getCountries(this.preferredCountries).map(function (country) {
        var currentCountry = Object.assign({}, country);
        currentCountry.preferred = true;
        return currentCountry;
      });
      var countriesList = preferredCountries.concat(this.filteredCountries);
      if (!this.dropdownOptions.showSearchBox) {
        return countriesList;
      }
      return countriesList.filter(function (c) {
        return new RegExp(_this2.searchQuery, "i").test(c.name) || new RegExp(_this2.searchQuery, "i").test(c.iso2) || new RegExp(_this2.searchQuery, "i").test(c.dialCode);
      });
    },
    phoneObject: function phoneObject() {
      var result = void 0;
      if (this.phone && this.phone[0] === "+") {
        result = (0, _libphonenumberJs.parsePhoneNumberFromString)(this.phone) || {};
      } else {
        result = (0, _libphonenumberJs.parsePhoneNumberFromString)(this.phone, this.activeCountryCode) || {};
      }
      var phoneObject = result;

      var valid = result.isValid;
      var formatted = this.phone;

      if (valid && typeof result.format === "function") {
        formatted = result.format(this.parsedMode.toUpperCase());
      }

      if (result.country && (this.ignoredCountries.length || this.onlyCountries.length)) {
        if (!this.findCountry(result.country)) {
          valid = false;
          Object.assign(result, { country: null });
        }
      }

      Object.assign(phoneObject, {
        countryCode: result.country,
        valid: valid,
        country: this.activeCountry,
        formatted: formatted
      });

      return phoneObject;
    },
    defaultColorClass: function defaultColorClass() {
      return this.inputTextColorClass;
    }
  },
  watch: {
    activeCountry: function activeCountry(value, oldValue) {
      if (!value && oldValue.iso2) {
        this.activeCountryCode = oldValue.iso2;
        return;
      }
      if (value.iso2) {
        this.$emit("country-changed", value);
        // this.resetPlaceholder();
      }
    },

    "phoneObject.countryCode": function phoneObjectCountryCode(value) {
      this.activeCountryCode = value || "";
    },
    "phoneObject.valid": function phoneObjectValid() {
      this.$emit("validate", this.phoneObject);
    },
    "phoneObject.formatted": function phoneObjectFormatted(value) {
      var _this3 = this;

      if (!this.autoFormat || this.customValidate) {
        return;
      }
      this.emitInput(value);

      this.$nextTick(function () {
        // In case `v-model` is not set, we need to update the `phone` to be new formatted value
        if (value && !_this3.value) {
          _this3.phone = value;
        }
      });
    },
    "inputOptions.placeholder": function inputOptionsPlaceholder() {
      this.resetPlaceholder();
    },
    value: function value(_value, oldValue) {
      var _this4 = this;

      if (!this.testCharacters()) {
        this.$nextTick(function () {
          _this4.phone = oldValue;
          _this4.onInput();
        });
      } else {
        this.phone = _value;
      }
    },
    open: function open(isDropdownOpened) {
      // Emit open and close events
      if (isDropdownOpened) {
        this.setDropdownPosition();
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    if (this.value) {
      this.phone = this.value.trim();
    }

    this.cleanInvalidCharacters();

    this.initializeCountry().then(function () {
      if (!_this5.phone && _this5.inputOptions && _this5.inputOptions.showDialCode && _this5.activeCountryCode) {
        _this5.phone = "+" + _this5.activeCountryCode;
      }
      _this5.$emit("validate", _this5.phoneObject);
    }).catch(console.error).then(function () {
      _this5.finishMounted = true;
    });
  },

  methods: {
    resetPlaceholder: function resetPlaceholder() {
      this.parsedPlaceholder = this.inputOptions.placeholder;
    },
    initializeCountry: function initializeCountry() {
      var _this6 = this;

      return new Promise(function (resolve) {
        /**
         * 1. If the phone included prefix (i.e. +12), try to get the country and set it
         */
        if (_this6.phone && _this6.phone[0] === "+") {
          resolve();
          return;
        }
        /**
         * 2. Use default country if passed from parent
         */
        if (_this6.defaultCountry) {
          if (typeof _this6.defaultCountry === "string") {
            _this6.choose(_this6.defaultCountry);
            resolve();
            return;
          }
          if (typeof _this6.defaultCountry === "number") {
            var country = _this6.findCountryByDialCode(_this6.defaultCountry);
            if (country) {
              _this6.choose(country.iso2);
              resolve();
              return;
            }
          }
        }

        var fallbackCountry = _this6.preferredCountries[0] || _this6.filteredCountries[0];
        /**
         * 3. Check if fetching country based on user's IP is allowed, set it as the default country
         */
        if (_this6.autoDefaultCountry) {
          (0, _utils.getCountry)().then(function (res) {
            _this6.choose(res || _this6.activeCountryCode);
          }).catch(function (error) {
            console.warn(error);
            /**
             * 4. Use the first country from preferred list (if available) or all countries list
             */
            _this6.choose(fallbackCountry);
          }).then(function () {
            resolve();
          });
        } else {
          /**
           * 4. Use the first country from preferred list (if available) or all countries list
           */
          _this6.choose(fallbackCountry);
          resolve();
        }
      });
    },

    /**
     * Get the list of countries from the list of iso2 code
     */
    getCountries: function getCountries() {
      var _this7 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return list.map(function (countryCode) {
        return _this7.findCountry(countryCode);
      }).filter(Boolean);
    },
    findCountry: function findCountry() {
      var iso = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      return this.filteredCountries.find(function (country) {
        return country.iso2 === iso.toUpperCase();
      });
    },
    findCountryByDialCode: function findCountryByDialCode(dialCode) {
      return this.filteredCountries.find(function (country) {
        return Number(country.dialCode) === dialCode;
      });
    },
    getItemClass: function getItemClass(index, iso2) {
      var highlighted = this.selectedIndex === index;
      var lastPreferred = index === this.preferredCountries.length - 1;
      var preferred = this.preferredCountries.some(function (c) {
        return c.toUpperCase() === iso2;
      });
      return {
        highlighted: highlighted,
        "last-preferred": lastPreferred,
        preferred: preferred
      };
    },
    choose: function choose(country) {
      var parsedCountry = country;
      if (typeof parsedCountry === "string") {
        parsedCountry = this.findCountry(parsedCountry);
      }

      if (!parsedCountry) {
        return;
      }

      if (this.phone && this.phone[0] === "+" && parsedCountry.iso2 && this.phoneObject.nationalNumber) {
        this.activeCountryCode = parsedCountry.iso2;
        // Attach the current phone number with the newly selected country
        this.phone = (0, _libphonenumberJs.parsePhoneNumberFromString)(this.phoneObject.nationalNumber, parsedCountry.iso2).formatInternational();
        return;
      }

      if (this.inputOptions && this.inputOptions.showDialCode && parsedCountry) {
        // Reset phone if the showDialCode is set
        this.phone = "+" + parsedCountry.dialCode;
        this.activeCountryCode = parsedCountry.iso2 || "";
        return;
      }

      // update value, even if international mode is NOT used
      this.activeCountryCode = parsedCountry.iso2 || "";
      this.emitInput(this.phone);
    },
    cleanInvalidCharacters: function cleanInvalidCharacters() {
      var currentPhone = this.phone;
      if (this.validCharactersOnly) {
        var results = this.phone.match(/[()\-+0-9\s]*/g);
        this.phone = results.join("");
      }

      if (this.customValidate && this.customValidate instanceof RegExp) {
        var _results = this.phone.match(this.customValidate);
        this.phone = _results.join("");
      }

      if (currentPhone !== this.phone) {
        this.emitInput(this.phone);
      }
    },
    testCharacters: function testCharacters() {
      if (this.validCharactersOnly) {
        var result = /^[()\-+0-9\s]*$/.test(this.phone);
        if (!result) {
          return false;
        }
      }
      if (this.customValidate) {
        return this.testCustomValidate();
      }
      return true;
    },
    testCustomValidate: function testCustomValidate() {
      return this.customValidate instanceof RegExp ? this.customValidate.test(this.phone) : false;
    },
    onInput: function onInput() {
      this.$refs.input.setCustomValidity(this.phoneObject.valid ? "" : this.invalidMsg);
      // Returns response.number to assign it to v-model (if being used)
      // Returns full response for cases @input is used
      // and parent wants to return the whole response.
      this.emitInput(this.phone);
    },
    emitInput: function emitInput(value) {
      this.$emit("input", value, this.phoneObject, this.$refs.input);
    },
    onBlur: function onBlur() {
      this.$emit("blur");
    },
    onFocus: function onFocus() {
      (0, _utils.setCaretPosition)(this.$refs.input, this.phone.length);
      this.$emit("focus");
    },
    onEnter: function onEnter() {
      this.$emit("enter");
    },
    onSpace: function onSpace() {
      this.$emit("space");
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    toggleDropdown: function toggleDropdown(e) {
      if (this.disabled || this.dropdownOptions.disabled || e.path && e.path[0].type && e.path[0].type === "text") {
        return;
      }
      this.searchQuery = "";
      this.open = !this.open;
    },
    clickedOutside: function clickedOutside() {
      this.open = false;
    },
    keyboardNav: function keyboardNav(e) {
      var _this8 = this;

      if (e.keyCode === 40) {
        // down arrow
        e.preventDefault();
        this.open = true;
        if (this.selectedIndex === null) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = Math.min(this.sortedCountries.length - 1, this.selectedIndex + 1);
        }
        var selEle = this.$refs.list.children[this.selectedIndex];
        selEle.focus();
        if (selEle.offsetTop + selEle.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight) {
          this.$refs.list.scrollTop = selEle.offsetTop - this.$refs.list.clientHeight + selEle.clientHeight;
        }
      } else if (e.keyCode === 38) {
        // up arrow
        e.preventDefault();
        this.open = true;
        if (this.selectedIndex === null) {
          this.selectedIndex = this.sortedCountries.length - 1;
        } else {
          this.selectedIndex = Math.max(0, this.selectedIndex - 1);
        }
        var _selEle = this.$refs.list.children[this.selectedIndex];
        _selEle.focus();
        if (_selEle.offsetTop < this.$refs.list.scrollTop) {
          this.$refs.list.scrollTop = _selEle.offsetTop;
        }
      } else if (e.keyCode === 13) {
        // enter key
        if (this.selectedIndex !== null) {
          this.choose(this.sortedCountries[this.selectedIndex]);
        }
        this.open = !this.open;
      } else {
        // typing a country's name
        this.typeToFindInput += e.key;
        clearTimeout(this.typeToFindTimer);
        this.typeToFindTimer = setTimeout(function () {
          _this8.typeToFindInput = "";
        }, 700);
        // don't include preferred countries so we jump to the right place in the alphabet
        var typedCountryI = this.sortedCountries.slice(this.preferredCountries.length).findIndex(function (c) {
          return c.name.toLowerCase().startsWith(_this8.typeToFindInput);
        });
        if (typedCountryI >= 0) {
          this.selectedIndex = this.preferredCountries.length + typedCountryI;
          var _selEle2 = this.$refs.list.children[this.selectedIndex];
          var needToScrollTop = _selEle2.offsetTop < this.$refs.list.scrollTop;
          var needToScrollBottom = _selEle2.offsetTop + _selEle2.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight;
          if (needToScrollTop || needToScrollBottom) {
            this.$refs.list.scrollTop = _selEle2.offsetTop - this.$refs.list.clientHeight / 2;
          }
        }
      }
    },
    reset: function reset() {
      this.selectedIndex = this.sortedCountries.map(function (c) {
        return c.iso2;
      }).indexOf(this.activeCountryCode);
      this.open = false;
    },
    setDropdownPosition: function setDropdownPosition() {
      var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > 200;
      if (hasEnoughSpaceBelow) {
        this.dropdownOpenDirection = "below";
      } else {
        this.dropdownOpenDirection = "above";
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/TelInput/TelInput.vue
// module id = QNRk
// module chunks = 0 1